module.exports = __webpack_public_path__ + "img/emoji_happy.aba24181.svg";